import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { GlgButton } from 'Shared/components'
import BaseCloningModal from './BaseCloningModal'
import { setCloningModal } from '../../../reducers/cloning_steps'
import { selectCloneLeaguesIndexURL } from '../../../reducers/session_saver'

const modalContent = (
  <>
    <span>{window.I18n.t('clone_leagues_sessions.modals.cancel_session.content_1')}</span>
    <span>{window.I18n.t('clone_leagues_sessions.modals.cancel_session.content_2')}</span>
  </>
)

const CancelSessionModal = () => {
  const dispatch = useDispatch()
  const cloneLeaguesIndexURL = useSelector(selectCloneLeaguesIndexURL)

  return (<BaseCloningModal
    title={window.I18n.t('clone_leagues_sessions.modals.cancel_session.title')}
    content={modalContent}
    leftButton={<GlgButton
      className={'cls-steps-modal__left_button'}
      text={window.I18n.t('clone_leagues_sessions.modals.cancel_session.cancel')}
      onClick={() => { window.location.href = cloneLeaguesIndexURL }}
    />}
    rightButton={<GlgButton
      className={'cls-steps-modal__right_button'}
      text={window.I18n.t('clone_leagues_sessions.modals.cancel_session.stay')}
      onClick={() => dispatch(setCloningModal(null))}
    />}
  />)
}

export default CancelSessionModal
